<div class="menu-float bg-base-font-primary/90" (click)="onCloseMenu()">
  <div class="menu-bar">
    <a class="menu-bar__school" routerLink="/">
      <img src="/assets/svg/logo-ea-branco.svg" [alt]="'global.adventist-education' | translate" />
      <div class="menu-bar__identifier">
        <span *ngIf="!!data.school.site_escola.tipo" class="menu-bar__type-school">
          {{ data.school.site_escola.tipo }}
        </span>
        <span *ngIf="!!data.school.site_escola.titulo" class="menu-bar__alias-school">
          {{ data.school.site_escola.titulo }}
        </span>
        <span class="menu-bar__name-school"> {{ legend(data) }} </span>
      </div>
    </a>

    <div class="menu-bar__menu">
      <span class="menu-bar__menu--indicator" (click)="onToogle($event)">
        {{ 'menu.more' | translate }}
      </span>
    </div>
  </div>
  <div class="menu-more__container">
    <div class="menu-more__card bg-base-font-primary/90" [ngClass]="{ 'menu-more__card--show': showMenu }">
      <div class="menu-more__static-items">
        <a *ngIf="!!data.pedagogical?.href" [href]="data.pedagogical.href" target="_blank" (click)="onCloseMenu()">
          {{ data.pedagogical.alt | translate }}
        </a>
        <a *ngIf="!!data.school.about" routerLink="/about" (click)="onCloseMenu()"> {{ 'menu.about' | translate }} </a>
        <a *ngIf="!!data.school.team?.length" routerLink="/team" (click)="onCloseMenu()">
          {{ 'menu.team' | translate }}
        </a>
        <a href="#location" (click)="onCloseMenu()"> {{ 'menu.location' | translate }} </a>
        <a
          *ngIf="data.school.url_ver_por_dentro"
          [href]="data.school.url_ver_por_dentro"
          target="_blank"
          (click)="onCloseMenu()"
        >
          {{ 'menu.tour' | translate }}
        </a>
        <ng-container *ngIf="!!data.enrolment; else runnableTemplate">
          <a class="menu-bar__menu--highlight" [href]="data.enrolment" target="_blank" (click)="onCloseMenu()">
            {{ 'menu.enrollments' | translate }}
          </a>
        </ng-container>
        <ng-template #runnableTemplate>
          <a class="menu-bar__menu--highlight" (click)="onSchedule()">
            {{ 'menu.enrollments' | translate }}
          </a>
        </ng-template>
      </div>
      <div *ngFor="let menu of data.menuMore">
        <h3>{{ menu.descricao }}</h3>
        <a *ngFor="let item of menu.menu_items" [href]="item.url" target="_blank" (click)="onCloseMenu()">
          {{ item.descricao }}
        </a>
      </div>
    </div>
  </div>
</div>
